import type {
  GroupedWorkspaceConfigModel,
  UserMeReadModel,
  WorkspaceWorkspaceReadModel
} from '@r/api/generated/client.schemas.ts';
import { getActiveWorkspaceUniversal } from '@r/helpers/api.ts';

const DEFAULT_CLIENT_PAGE_TITLE_SUFFIX = 'Fiddy';

export const getClientWorkspacePageTitleSuffix = (
  workspaceConfig?: GroupedWorkspaceConfigModel,
  workspace?: WorkspaceWorkspaceReadModel | null,
  user?: UserMeReadModel | null
): string => {
  const fromConfigTitle = workspaceConfig?.groupedConfigs?.core?.title;
  if (fromConfigTitle) {
    return fromConfigTitle;
  }

  const fromConfigName = workspaceConfig?.groupedConfigs?.core?.name;
  if (fromConfigName) {
    return fromConfigName;
  }

  if (workspace?.name) {
    return workspace.name;
  }

  const activeWorkspace = getActiveWorkspaceUniversal(user?.visibleWorkspaces);
  if (activeWorkspace?.workspace?.name) {
    return activeWorkspace.workspace.name;
  }

  return DEFAULT_CLIENT_PAGE_TITLE_SUFFIX;
};
